import _ from 'lodash';
import $ from 'jquery';
import { translate } from '@openclassrooms/translations';

/**
 * @typedef {Object} OverlayOptionTypedef
 * @property {HTMLElement} [elementToAttach]
 * @property {Boolean} [invisibleBackground]
 * @property {Boolean} [loadingCursor]
 * @property {Boolean} [whiteSemiTransparentBackground]
 * @property {Boolean} [loaderMargin]
 * @property {Boolean} [iconLoader]
 * @property {String} [loaderText]
 */

const LOADER_SELECTOR = '.loader';

/**
 * @param {String} loaderText
 * @return {jQuery}
 */
function getLoader(loaderText) {
  return $(
    '<div class="loader">' +
      '   <span>' +
      '       <i class="icon-spinner icon-spinner icon-spin"></i> ' +
      loaderText +
      '   </span>' +
      '</div>'
  );
}

/**
 * @param {jQuery} $overlay
 * @param {Boolean} state
 * @param {OverlayOptionTypedef} [options]
 */
function toggleOverlay($overlay, state, options) {
  positionOverlay($overlay, options);
  decorateOverlay($overlay, options);

  if (typeof state === 'undefined') {
    $overlay.toggle();
  } else {
    $overlay[state ? 'show' : 'hide']();
  }
}

/**
 * @param {jQuery} $overlay
 * @param {OverlayOptionTypedef} options
 */
function positionOverlay($overlay, options) {
  var position = { top: 0, bottom: 0, left: 0, right: 0 },
    $element,
    offset;

  if (options && options.elementToAttach) {
    $element = $(options.elementToAttach);
    offset = $element.offset();

    position.top = offset.top;
    position.left = offset.left;

    $overlay
      .width($element.outerWidth())
      .height($element.outerHeight())
      .css('position', 'absolute')
      .css('display', 'inline-block');
  } else {
    $overlay.width('').height('').css('position', 'fixed');
  }

  $overlay.css(position);
}

/**
 * @param {jQuery} $overlay
 * @param {OverlayOptionTypedef} options
 */
function decorateOverlay($overlay, options) {
  var isTransparent = options && options.invisibleBackground === true,
    isLoading = options && options.loadingCursor === true,
    isWhite = options && options.whiteSemiTransparentBackground === true,
    isLoader = options && options.iconLoader === true;

  $overlay.toggleClass('is-transparent', isTransparent);
  $overlay.toggleClass('is-loading', isLoading);
  $overlay.toggleClass('is-white', isWhite);

  if (isLoader) {
    $(LOADER_SELECTOR, $overlay).fadeIn(1000);
  } else {
    $(LOADER_SELECTOR, $overlay).hide();
  }
}

class OverlayService {
  /**
   * @param {OverlayOptionTypedef} options
   */
  constructor(options) {
    this.id = _.uniqueId();
    this.options = options;
    if (_.isNil(this.options.loaderText)) {
      this.options.loaderText = translate('global.word.loading');
    }
  }

  /**
   * @return {jQuery}
   */
  get() {
    let $overlay = $('.js-overlay' + this.id);

    if (!$overlay.length) {
      $overlay = $('<div>')
        .hide()
        .prependTo($('body'))
        .addClass('overlay')
        .addClass('js-overlay' + this.id)
        .css('z-index', 1000)
        .css('text-align', 'center')
        .prepend(getLoader(this.options.loaderText));

      if (this.options.loaderMargin) {
        let overlayLoader = $overlay.find(LOADER_SELECTOR);
        overlayLoader.addClass('margin');
      }
    }

    return $overlay;
  }

  open() {
    toggleOverlay(this.get(), true, this.options);
  }

  close() {
    toggleOverlay(this.get(), false);
  }

  /**
   * @param {Boolean} state
   */
  toggle(state) {
    toggleOverlay(this.get(), state, this.options);
  }
}

export default OverlayService;
